import { Company } from '@models/Company'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { COMPANY_URL } from '@utils/urls'

const fetchCompanies = (params: TableParams) =>
  SBAPI.FetchPaginated<Company[]>(COMPANY_URL, params)

const fetchCompanyById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Company>(`${COMPANY_URL}/${id}`, params)

const createCompany = (company: Company) => SBAPI.Post(COMPANY_URL, company)

const updateCompany = (company: Company) =>
  SBAPI.Put(`${COMPANY_URL}/${company.id}`, company)

const deleteCompany = (company: Company) =>
  SBAPI.Delete(`${COMPANY_URL}/${company.id}`)

export {
  createCompany,
  deleteCompany,
  fetchCompanies,
  fetchCompanyById,
  updateCompany,
}
